/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tenant tier enum matching database
 */
export enum TenantTier {

    Free = 'Free',

    Premium = 'Premium',

    Enterprise = 'Enterprise',

    Internal = 'Internal'
}
